export const ReferToPage = (destinationLang) => {
  return [
    {
      FormKey: "general-public-refer-to",
      Key: "ارجاع به",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "refer-to-label-sessions",
      Key: "جلسات",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "refer-to-numeric-session-count",
      Key: "تعداد جلسات",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "refer-to-numeric-days-gap",
      Key: "فاصله روز ها",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "general-public-history",
      Key: "تاريخ",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "refer-to-check-special-days",
      Key: "روز هاي خاص",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "refer-to-select-days-of-week",
      Key: "روز هاي هفته",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "refer-to-btn-get-date-list",
      Key: "دريافت فهرست تاريخ",
      DistinitationLanguage: destinationLang,
    },

    {
      FormKey: "refer-to-select-days-of-week",
      Key: "روز هاي هفته",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "general-public-label-diagnose",
      Key: "تشخيص",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "general-public-label-doctors-list",
      Key: "پزشکان",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "refer-to-btn-save",
      Key: "ثبت",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "confirm-alert-msg-confrim-add-erja",
      Key: "آیا از ثبت ارجاع مطمئن هستید؟",
      DistinitationLanguage: destinationLang,
    },
  ];
};
